// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** Get current user GET /api/currentUser */
export async function getCurrentUser(options?: { [key: string]: any }) {
  return request<API.CurrentUserResponse>("/api/currentUser", {
    method: "GET",
    ...(options || {}),
  });
}

export type UserProfile = {
  userId: string;
  name: string;
  email: string;
  role: string;
  lineId: string;
  photoUrl?: string | null;
  comment?: string | null;
  createdAt: string;
  updatedAt: string;
};

export async function getMe() {
  return request<UserProfile>('/me', { method: 'GET' });
}

/** Update user PUT /api/user */
export async function putUser(
  body: API.UserUpsertRequest,
  options?: { [key: string]: any }
) {
  return request<API.StatusSuccessResponse>("/users", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** Create user POST /api/user */
export async function createUser(
  body: {
    name: string;
    mail: string;
    role: 'admin' | 'worker';
    lineId: string;
    comment?: string;
    photoUrl?: string;
  },
  options?: { [key: string]: any }
) {
  return request<{ ok: true; userId: string }>('/users', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}


/** Delete users (by ids in body) DELETE /api/user */
export async function deleteUser(
  body: API.DeleteByIdsRequest,
  options?: { [key: string]: any }
) {
  return request<API.StatusSuccessResponse>("/users/delete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** Get user list GET /api/user_list */
export async function listUsers(params?: {
  email?: string;
  lineId?: string;
  role?: string;
  nextToken?: string;
}) {
  return request('/users', {
    method: 'GET',
    params,
  });
}
